<template>
    <div ref="page-pc" class="page-pc" :style="rootStyle">
        <flow-container :children="tpl.children" class="page-pc-child"></flow-container>
    </div>
</template>
<script>
const { plugins: { ComplexComp } } = FEGORender;
const { rem: { parseStyle } } = window.FEGOUtils;

export default {
    props: ["tpl"],
    name: "page-pc",
    components: {
        FlowContainer: ComplexComp.Container.Flow,
    },
    computed: {
        rootStyle() {
            return parseStyle(this.tpl.style || {});
        }
    },
};
</script>
<style lang="less" scoped>
.page-pc {
    height: auto !important;
    width: 100% !important;
    margin: auto;

    .page-pc-child {
        overflow: hidden;
        min-width: 13.66rem;
    }
}
</style>



// WEBPACK FOOTER //
// src/render/index.vue